import { Store } from '@ngrx/store';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';
import { FormGroup } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { VisaDesignerService } from '../../../services/visa-designer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import * as RolesRouteMap from '../../../data/constants/roles';
import { take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ReferenceLibraryService } from 'src/app/services/referenceLibrary.service';
import * as fromVDTask from '../vd-state/reducers/vd.reducer';
import { CustomErrorToastComponent } from 'custom-error-toast';


@Component({
  selector: 'app-drag-drop-poc',
  templateUrl: './poc.component.html',
  styleUrls: ['../visa-designer.scss', './poc.component.scss'],
  // viewProviders:[{provide:ControlContainer,useExisting: FormGroupDirective }]
})
export class PocComponent implements OnInit, OnDestroy {

  placeHolderObj = { controlType: 'STANDARD' };
  placeHolderCustom = { controlType: 'CUSTOM' };
  emailComp;

  // addForm: FormGroup;
  addForm = new FormGroup({});
  column: any = 4;
  htmlRenderObj: any = [];
  placeHolderStandardArray = [];
  placeHolderCustomArray = [];
  placeHolderFilter: string;
  data: any = {};
  user = false;
  components: any = [];
  url: any;
  visaId: any;
  finalData: any = {};
  printData: any = {};
  observableSubscription$ = new Subject();
  myParam;
  palette: any = {};
  paletteIndex: any = 0;
  // addForm: FormGroup;
  titlePalette: any;
  displayPalette = false;
  showTabs: any = 'general';
  coorsArray: any = [];
  isPreview = false;
  resultObj: any = [];
  customStepId: any = localStorage.getItem('customStepId');
  preDefinedArrayList: any = [];
  familyRelTypeArr: any = [];
  isView: boolean = false;
  actionButton: any;
  isEditVisa: boolean = false;
  
  // addForm = new FormGroup({});

  constructor(
    private toastr: ToastrService,
    private cRef: ChangeDetectorRef, private VDService: VisaDesignerService,
    private router: Router, private route: ActivatedRoute,
    private confirmationService: ConfirmationService, private referenceLibraryService: ReferenceLibraryService, private store: Store<any>) {
    this.preDefinedArrayList = ['AddressDetailsComponent', 'WorkLocationComponent',
      'JobDutiesComponent', 'CreateTaskActionsComponent', 'EmailAddressComponent',
      'TaskDetailsComponent', 'CommonQuestionsComponent', 'H1bTaskQuestionsComponent',
      'SubTaskPetitionDetailsComponent', 'ClientDetailsLibraryComponent',
      'CreateTaskLibraryComponent', 'SubTaskExtraOrdinaryAbility', 'VdSubTaskH4Component',
      'VdConfigPetitionSubTaskComponent', 'VdH4TaskDetailsComponent','SubTaskInterpreterDetailsComponent'];
  }

  ngOnInit() {
    const getUrl = this.router.url;
    const splitUrl = getUrl.split('/');
    this.url = splitUrl[6];
    this.column = 4;
    this.visaId = localStorage.getItem('visaId');
    this.isEditVisa = localStorage.getItem('isEditVisa') === 'true' ? true : false;
    this.getTemplate();
    this.getRelationshipCodeArray();
    // this.route.queryParams.pipe(takeUntil(this.observableSubscription$)).subscribe((params) => {
    //   this.visaId = params['id'] || null;
    //   this.getTemplate();
    // });
    this.route.params.subscribe((params) => {
      // console.log(params);
      this.isView = (params['isView'] === 'view') ? true : false;
    });
    if (this.url.indexOf('task-details') >= 0) {
      this.VDService.getPlaceHolderControls(this.placeHolderObj).subscribe(data => {
        this.placeHolderStandardArray = data.data.filter(item => this.preDefinedArrayList.includes(item.layoutCode));
      });

      this.VDService.getPlaceHolderControls(this.placeHolderCustom).subscribe(data => {
        this.placeHolderCustomArray = data.data;
        // this.placeHolderCustomArray.push(this.actionButton);
      });

    }
    else if (this.url == 'timeline-steps') {
    }
  }

  getTemplate() {
    this.VDService.getTaskDetailsTemplates(this.visaId).subscribe(response => {
      if (JSON.parse(response.data.taskJson) != null) {
        this.htmlRenderObj = JSON.parse(response.data.taskJson);
      }
    });
  }

  getRelationshipCodeArray() {
    this.referenceLibraryService.getReferenceData('FAMRELTYP')
      .subscribe(data => {
        this.familyRelTypeArr = data;
        // this.setDependentTabItems();

      });
  }

  removeBox(index: any) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      header: 'Delete',
      accept: () => {
        this.htmlRenderObj.splice(index, 1);
        const stringObj = JSON.stringify(this.htmlRenderObj);
        const postObj = {
          taskJson: stringObj,
          visaId: this.visaId,
        };
        this.VDService.saveTaskDetailsTemplates(postObj).subscribe(res => {
          this.toastr.success('You have succcessfully deleted', 'Success');
          this.getTemplate();
          return res;
        });
      },
      reject: () => {
      }
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.htmlRenderObj, event.previousIndex, event.currentIndex);
  }

  onDragEnd(event, data: any) {
    event.preventDefault();

    if (data.label) {
      data.name = data.label.toUpperCase() + '_' + Math.random();
      data.groupName = data.name;
    } else {
      data.name = Math.random();
      data.groupName = data.name;
    }

    const y = {
      align: null,
      controlElementType: 'GROUP',
      controlName: 'VdSubTaskH4Component',
      controlType: 'STANDARD',
      coordinateX: null,
      coordinateY: null,
      editMode: false,
      groupElementProperty: null,
      groupName: null,
      label: 'Vd SubTask H4',
      layoutCode: 'VdSubTaskH4Component',
      isConfigurable: true,
      mandatory: false,
      maxLength: null,
      minLength: null,
      name: null,
      placeholder: null,
      properties: null,
      questionCheck: false,
      questionText: null,
      readonly: false,
      style: null,
      subText: null,
      value: null,
      fieldConfiguration: [
        {
          showField: true,
          label: 'outside imagility',
          fieldName: 'showOutsideImagilityQuestion'
        },
        {
          showField: true,
          label: 'primary applicant',
          fieldName: 'showPrimaryApplicantSection'
        },
        {
          showField: true,
          label: 'applicant Detail',
          fieldName: 'showApplicantDetailSection'
        }
      ]
    };

    const z = {
      align: null,
      controlElementType: 'GROUP',
      controlName: 'VdConfigPetitionSubTaskComponent',
      controlType: 'STANDARD',
      coordinateX: null,
      coordinateY: null,
      editMode: false,
      groupElementProperty: null,
      groupName: null,
      label: 'Vd Petition SubTask',
      layoutCode: 'VdConfigPetitionSubTaskComponent',
      isConfigurable: true,
      mandatory: false,
      maxLength: null,
      minLength: null,
      name: null,
      placeholder: null,
      properties: null,
      questionCheck: false,
      questionText: null,
      readonly: false,
      style: null,
      subText: null,
      value: null,
      fieldConfiguration: [
        {
          showField: true,
          label: 'Show ServiceCenter Section',
          fieldName: 'showServiceCenterSection'
        },
        {
          showField: false,
          label: 'Show Signatory Section',
          fieldName: 'showSignatorySection'
        },
        {
          showField: true,
          label: 'Show Attorney Section',
          fieldName: 'showAttorneySection'
        },
        {
          showField: true,
          label: 'Show Petitioner Preparer Section',
          fieldName: 'showPetitionerSection'
        }
      ]
    };

    var k = {
      "label": "Vd H4 Task Details",
      "subText": null,
      "controlName": "VdH4TaskDetailsComponent",
      "layoutCode": "VdH4TaskDetailsComponent",
      "controlType": "STANDARD",
      "controlElementType": "GROUP",
      "coordinateX": null,
      "coordinateY": null,
      "align": null,
      "mandatory": false,
      "readonly": false,
      "minLength": null,
      "maxLength": null,
      "placeholder": null,
      "name": null,
      "value": null,
      "style": null,
      "questionText": null,
      "questionCheck": false,
      "groupElementProperty": null,
      "properties": null,
      "editMode": false,
      "groupName": null,
      "fieldConfiguration": [{
        "label": "Enter Beneficiary/Sponser field label name",
        "fieldName": "beneficiaryFieldLabelName",
        "showField": true,
        "fieldType": "inputText",
        "value": "test1"
      },],
      "gridValues": null,
      "gridProperties": null,
      "checkboxLabel": null,
      "isConfigurable": true,
      "isChecked": false,
      "isDisabled": false
    }


    var p = {
      "label": "Vd H4 Task Details",
      "subText": null,
      "controlName": "VdH4TaskDetailsComponent",
      "layoutCode": "VdH4TaskDetailsComponent",
      "controlType": "STANDARD",
      "controlElementType": "GROUP",
      "coordinateX": null,
      "coordinateY": null,
      "align": null,
      "mandatory": false,
      "readonly": false,
      "minLength": null,
      "maxLength": null,
      "placeholder": null,
      "name": null,
      "value": null,
      "style": null,
      "questionText": null,
      "questionCheck": false,
      "groupElementProperty": null,
      "properties": null,
      "editMode": false,
      "groupName": null,
      "fieldConfiguration": [],
      "gridValues": null,
      "gridProperties": null,
      "checkboxLabel": null,
      "isConfigurable": true,
      "isChecked": false,
      "isDisabled": false
    }

    var a = {
      "label": "Vd SubTask H4",
      "subText": null,
      "controlName": "VdSubTaskH4Component",
      "layoutCode": "VdSubTaskH4Component",
      "controlType": "STANDARD",
      "controlElementType": "GROUP",
      "coordinateX": null,
      "coordinateY": null,
      "align": null,
      "mandatory": false,
      "readonly": false,
      "minLength": null,
      "maxLength": null,
      "placeholder": null,
      "name": null,
      "value": null,
      "style": null,
      "questionText": null,
      "questionCheck": false,
      "groupElementProperty": null,
      "properties": null,
      "editMode": false,
      "groupName": null,
      "fieldConfiguration": [
        {
          "label": "outside imagility",
          "fieldName": "showOutsideImagilityQuestion",
          "showField": true,
          "fieldType": "inputSwitch",
          "value": "test1"
        },
        {
          "label": "primary applicant",
          "fieldName": "showPrimaryApplicantSection",
          "showField": true,
          "fieldType": "inputSwitch",
          "value": "test1",
          "dependentList": []
        },
        {
          "label": "applicant Detail",
          "fieldName": "showApplicantDetailSection",
          "showField": true,
          "fieldType": "inputSwitch",
          "questionLabelText": "test1",
          "enableSwitch": false,
          "showPrimaryApplicantToo": false

        },

      ],
      "gridValues": null,
      "gridProperties": null,
      "checkboxLabel": null,
      "isConfigurable": true,
      "isChecked": false,
      "isDisabled": false
    }




    //this.htmlRenderObj.push(a);
    this.htmlRenderObj.push(data);
    this.VDService.getPlaceHolderControls(this.placeHolderCustom)
      .subscribe((dataPlaceHolderControls) => {
        this.placeHolderCustomArray = dataPlaceHolderControls.data;
      });
    // this.cRef.detectChanges();
    this.column = this.column;
    this.cRef.detectChanges();
  }

  columnChange(value: any) {
    this.column = value;
  }

  openPalette(index) {
    this.palette = {};
    this.paletteIndex = index;
    this.displayPalette = true;
    this.palette = this.htmlRenderObj[index];
    this.cRef.detectChanges();
  }
  backSetting() {
    this.displayPalette = false;
  }

  tabs(val) {
    this.showTabs = val;
  }
  requiredValidation(event) {
    this.palette.mandatory = event.checked;
  }
  hideField(event) {

  }

  readonly(event) {
    this.palette.readonly = event.checked;
  }
  deleteField() {
    this.htmlRenderObj.splice(this.paletteIndex, 1);
  }

  addCoordinates(calculatXCoords, calculatYCoords, _data, index) {
    if (this.coorsArray.length == 0) {
      this.coorsArray.push({ 'coordinateX': calculatXCoords, 'coordinateY': calculatYCoords, 'name': _data.name });
    }
    else {
      const getIdx = this.coorsArray.map((el) => {
        return el.name;
      }).indexOf(this.htmlRenderObj[index].name);

      if (getIdx >= 0) {
        this.coorsArray[getIdx]['coordinateX'] = calculatXCoords;
        this.coorsArray[getIdx]['coordinateY'] = calculatYCoords;
      }
      else {
        this.coorsArray.push({ 'coordinateX': calculatXCoords, 'coordinateY': calculatYCoords, 'name': _data.name });
      }
    }
  }

  saveSetting() {
    this.htmlRenderObj[this.paletteIndex] = this.palette;
    // this.componentLoader.loadComponent();
    this.cRef.detectChanges();
    // for(var i=0; i<this.coorsArray.length; i++){
    //   const getIndex = this.htmlRenderObj.map((item) => {
    //     return item.name;
    //   }).indexOf(this.coorsArray[i].name);
    //   if(getIndex >= 0){
    //     this.htmlRenderObj[getIndex]['coordinateX'] = this.coorsArray[i]['coordinateX'];
    //     this.htmlRenderObj[getIndex]['coordinateY'] = this.coorsArray[i]['coordinateY'];
    //   }
    // }

    // for(var i=0; i<this.htmlRenderObj.length; i++){
    //   this.htmlRenderObj[i].editMode = true;
    // }
    // this.resultObj[this.customStepId]['controlArray'] = this.htmlRenderObj;
    // const payload = {
    //   stepJson: JSON.stringify(this.resultObj),
    //   visaId: this.visaId
    // }
    // this.VDService.createVisa(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
    //   if (response && response.status === 200) {
    //      this.getTemplate();
    //      this.toastr.success('Step controller is successfully saved');
    //     //  localStorage.setItem('customStepId', null);
    //     //  this.router.navigate([`../timeline-steps`], { queryParams: {id: this.visaId}, relativeTo: this.route });
    //      return false;
    //   }
    // });
    const stringObj = JSON.stringify(this.htmlRenderObj);
    const postObj = {
      taskJson: stringObj,
      visaId: this.visaId,
    };
    this.VDService.saveTaskDetailsTemplates(postObj).subscribe(res => {
      if (res?.status === 200) {
        this.toastr.success(res?.message, 'Success');
        this.getTemplate();
      }
    });
  }

  onSubmit(event) {
    if (this.isView || !this.isEditVisa) {
      this.navigateToNext();
      return;
    }
    console.warn(this.addForm.value);
    const count = document.querySelectorAll('.elementCount');

    if (count.length > 45) {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'You can not add more then 45 fields');
      return false;
    }

    const stringObj = JSON.stringify(this.htmlRenderObj);
    const postObj = {
      taskJson: stringObj,
      visaId: this.visaId,
    };
    this.VDService.saveTaskDetailsTemplates(postObj).subscribe(res => {
      if (res?.status === 200) {
        this.toastr.success(res?.message, 'Success');
        this.navigateToNext();
      }
    });
    return false;

  }

  navigateToNext() {

    this.store.select(fromVDTask.getVDBuildType).pipe(take(1)).subscribe(formVDState => {
      switch (formVDState) {
        case 'pdf':
          if (this.isView) {
            this.router.navigate([`../../upload-pdf/view`], { relativeTo: this.route });
          } else {
            this.router.navigate([`../upload-pdf`], { relativeTo: this.route });
          }
          break;
        case 'build':
        case 'old':
          if (this.isView) {
            this.router.navigate([`../../timeline-steps/view`], { queryParams: { id: this.visaId }, relativeTo: this.route });
          } else {
            this.router.navigate([`../timeline-steps`], { queryParams: { id: this.visaId }, relativeTo: this.route });
          }
          break;
        default:
          this.router.navigate(['../../../../manage-visa/created-visas'], { relativeTo: this.route });
          break;
      }
    });
  }

  cancelTemplate(event) {
    console.warn(event);
    this.htmlRenderObj = [];
  }

  hadleCancel() {
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/visa-designer/manage-visa/`]);
  }
  goTimeline() {
    this.router.navigate([`../timeline-steps`], { queryParams: { id: this.visaId }, relativeTo: this.route });
  }
  ngOnDestroy() {
    this.htmlRenderObj = null;
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

  editEvent(event) {
  }
  saveEvent(event) {
  }
  cancelEvent(event) {
  }
}
